export default class ColorsHelper {
  static readonly ACTION_STATUS_BAR_COLORS = {
    MonitorMaintenance: '#FADA7E',
    NoAction: '#87BF8A',
    NoActionOk: '#87BF8A',
    ChangeoutImmediately: '#541311',
    ScheduleChangeout: '#E39192',
    NoMeasurements: '#BEBCBD',
    InvalidMeasurements: '#BEBCBD',
  };

  static getContrastColor = (hexColor?: string): string => {
    // Input validation
    if (hexColor == undefined || !hexColor.match(/^#?[0-9A-Fa-f]{6}$/)) {
      console.error(new Error('Invalid hex color format'));
      return '#ffffff'; // Default to white if invalid
    }

    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5 ? '#000000' : '#ffffff';
  };
}
